export const SIZES = {
  tiny: 'tiny',
  large: 'large',
};
